import { useTranslation } from "react-i18next";
import {
  StageShell, ColumnHeader, Metric, NumField,
} from "./primitives";

export default function Stage2Amc({
  amcMonthlyPct, setAmcMonthlyPct,
  amcSetupPct, setAmcSetupPct,
  calc, fmtM,
}) {
  const { t } = useTranslation();

  return (
    <StageShell
      step={t("jc2_step")}
      role={t("jc2_role")}
      title={t("jc2_title")}
      desc={t("jc2_desc")}
      accentBg="bg-[#002FA7]"
      accentText="text-[#FFCC00]"
    >
      <div className="grid grid-cols-12 gap-6 mt-6">
        <div className="col-span-12 md:col-span-5">
          <ColumnHeader label={t("jc_stage_in")} accent="text-zinc-700" />
          <div className="space-y-5 border border-black/10 bg-white p-5">
            <NumField
              id="mfee"
              label={t("jc2_in_mfee")}
              tip={t("tip_mfee")}
              value={amcMonthlyPct}
              step={0.5}
              min={0}
              onChange={setAmcMonthlyPct}
              suffix="%"
            />
            <NumField
              id="sfee"
              label={t("jc2_in_sfee")}
              tip={t("tip_sfee")}
              value={amcSetupPct}
              step={0.5}
              min={0}
              onChange={setAmcSetupPct}
              suffix="%"
            />
          </div>
        </div>

        <div className="col-span-12 md:col-span-7">
          <ColumnHeader label={t("jc_stage_out")} accent="text-[#002FA7]" />
          <div className="grid grid-cols-2 gap-px bg-black/10 border border-black/10">
            <div className="bg-white p-5">
              <Metric k={t("jc2_out_eff")} v={fmtM(calc.monthlyNet, 0)} tip={t("tip_eff")} />
            </div>
            <div className="bg-white p-5">
              <Metric k={t("jc2_out_net")} v={fmtM(calc.netToInvestors, 0)} accent="text-[#002FA7]" tip={t("tip_net")} />
            </div>
            <div className="bg-[#002FA7] text-white p-5 col-span-2">
              <Metric k={t("jc2_out_raise")} v={fmtM(calc.targetRaise, 0)} accent="text-[#FFCC00]" big tip={t("tip_raise")} />
            </div>
            <div className="bg-white p-5">
              <Metric k={t("jc2_out_price")} v={fmtM(calc.pricePerCoin, 2)} tip={t("tip_price")} />
            </div>
            <div className="bg-white p-5">
              <Metric k={t("jc2_out_advance")} v={fmtM(calc.landlordAdvance, 0)} tip={t("tip_advance")} />
            </div>
            <div className="bg-white p-5">
              <Metric k={t("jc2_out_sfee")} v={fmtM(calc.amcSetupFee, 0)} tip={t("tip_sfee_out")} />
            </div>
            <div className="bg-white p-5">
              <Metric k={t("jc2_out_mfee")} v={fmtM(calc.amcMonthlyFee, 0)} tip={t("tip_mfee_out")} />
            </div>
          </div>
        </div>
      </div>
    </StageShell>
  );
}
